export enum CompleterType {
  Contact = 'Contact',
  User = 'User',
}

export enum OmniRiskProfileEmailTemplate {
  ClientEdit = 'r-p-r-client-edit',
  CompletedQuestionnaire = 'risk-profile-complete',
  OneTimePassword = 'risk-profile-otp',
  QuestionnaireInvitation = 'risk-profile-invite',
  RefreshAccepted = 'r-p-r-accept',
  RefreshReview = 'r-p-r-review',
}

export enum OmniRiskProfileStatus {
  Approved = 'APPROVED',
  ClientReview = 'CLIENT_REVIEW',
  ClientReviewUnsent = 'CLIENT_REVIEW_UNSENT',
  Pending = 'PENDING',
  Review = 'REVIEW',
  Sent = 'SENT',
  SentRefresh = 'SENT_REFRESH',
}

export enum OmniRiskProfileStatusColors {
  Blue = 'blue',
  Green = 'green',
  Grey = 'grey',
  Yellow = 'yellow',
}

export enum OmniRiskProfileSteps {
  NAME_PROFILE,
  CREATE_QUESTIONNAIRE,
  SEND_INVITE_QUESTIONNAIRE,
  SEND_REFRESH_QUESTIONNAIRE,
  SEND_REVIEW_QUESTIONNAIRE,
  COMPLETE_QUESTIONNAIRE,
  DELETE_RISK_PROFILE,
}

export enum OmniRiskProfileStepsTitlesKeys {
  CompleteQuestionnaire = 'RiskProfileModal.CompleteQuestionnaire.Title',
  CreateQuestionnaire = 'RiskProfileModal.CreateQuestionnaire.Title',
  DeleteRiskProfile = 'RiskProfileModal.DeleteRiskProfile.Title',
  NameRiskProfile = 'RiskProfileModal.NameRiskProfile.Title',
  RefreshQuestionnaire = 'RiskProfileModal.RefreshQuestionnaire.Title',
  SendQuestionnaire = 'RiskProfileModal.SendQuestionnaire.Title',
  SendQuestionnaireForReview = 'RiskProfileModal.SendQuestionnaire.SendQuestionnaireForReview',
  SendRefreshQuestionnaire = 'RiskProfileModal.SendQuestionnaire.SendRefreshQuestionnaire',
}

export enum OmniRiskProfilesTableKeys {
  Name = 'name',
  Profile = 'profile',
  Status = 'status',
  CompletedBy = 'completedBy',
  UpdatedAt = 'updatedAt',
}
